module.exports = __webpack_public_path__ + "media/images/styleline-0197ef3df12f80254129e3283696d554.png";